export const getFileType = (filename: string) => {
  const ImageTypes = ['jpg', 'png', 'svg', 'jpeg'];
  const fileType = filename?.substring(filename?.lastIndexOf('.') + 1);
  if (ImageTypes.includes(fileType)) {
    return 'img';
  }
  return fileType;
};
